'use client';

import { type TableOfContentProps, type TocItem, TableOfContent } from '@pixum/table-of-content';
import { trackEvent, isBrowser, TRACKING_CATEGORIES, scrollToElementIntoView } from 'utils';

interface TableOfContentCollectionProps extends Omit<TableOfContentProps, 'title' | 'floatingButtonAriaLabel'> {
  constants: Record<string, string>;
}

export function TableOfContentCollection({ constants, onItemClick, ...props }: TableOfContentCollectionProps) {
  const handleItemClick = (item: TocItem) => {
    const currentUrl = isBrowser() ? window.location.href : '';

    trackEvent(TRACKING_CATEGORIES.JUMP_LINK, currentUrl, item.label);
    scrollToElementIntoView(item.id);
    onItemClick?.(item);
  };

  return (
    <section className="editorial-section">
      <TableOfContent
        {...props}
        title={constants['i18n_editorial_toc_title']}
        floatingButtonAriaLabel={constants['i18n_editorial_toc_button_aria-label']}
        onItemClick={handleItemClick}
      />
    </section>
  );
}
